var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 4.25H17.75V4C17.75 3.59 17.41 3.25 17 3.25C16.59 3.25 16.25 3.59 16.25 4V4.25H12.75V4C12.75 3.59 12.41 3.25 12 3.25C11.59 3.25 11.25 3.59 11.25 4V4.25H7.75V4C7.75 3.59 7.41 3.25 7 3.25C6.59 3.25 6.25 3.59 6.25 4V4.25H6C3.93 4.25 2.25 5.93 2.25 8V18C2.25 20.07 3.93 21.75 6 21.75H18C20.07 21.75 21.75 20.07 21.75 18V8C21.75 5.93 20.07 4.25 18 4.25ZM20.25 18C20.25 19.24 19.24 20.25 18 20.25H6C4.76 20.25 3.75 19.24 3.75 18V8C3.75 6.76 4.76 5.75 6 5.75H6.25V6C6.25 6.41 6.59 6.75 7 6.75C7.41 6.75 7.75 6.41 7.75 6V5.75H11.25V6C11.25 6.41 11.59 6.75 12 6.75C12.41 6.75 12.75 6.41 12.75 6V5.75H16.25V6C16.25 6.41 16.59 6.75 17 6.75C17.41 6.75 17.75 6.41 17.75 6V5.75H18C19.24 5.75 20.25 6.76 20.25 8V18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.2499H8C7.59 10.2499 7.25 10.5899 7.25 10.9999C7.25 11.4099 7.59 11.7499 8 11.7499H16C16.41 11.7499 16.75 11.4099 16.75 10.9999C16.75 10.5899 16.41 10.2499 16 10.2499Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.2499H8C7.59 14.2499 7.25 14.5899 7.25 14.9999C7.25 15.4099 7.59 15.7499 8 15.7499H12C12.41 15.7499 12.75 15.4099 12.75 14.9999C12.75 14.5899 12.41 14.2499 12 14.2499Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarPost);
export default __webpack_public_path__ + "static/media/CalendarPost.ce6e829b.svg";
export { ForwardRef as ReactComponent };